import React from 'react';
import styled from 'styled-components';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

import { Section, Container } from '@components/global';

const About = () => (
  <StaticQuery
    query={graphql`
      query {
        art_fast: file(
          sourceInstanceName: { eq: "art" }
          name: { eq: "assets" }
        ) {
          childImageSharp {
            fluid(maxWidth: 760) {
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }

        art_learn: file(
          sourceInstanceName: { eq: "art" }
          name: { eq: "arch" }
        ) {
          childImageSharp {
            fluid(maxWidth: 760) {
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }

        art_ideas: file(
          sourceInstanceName: { eq: "art" }
          name: { eq: "startu" }
        ) {
          childImageSharp {
            fluid(maxWidth: 760) {
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }
      }
    `}
    render={data => (
      <Section id="services">
        <Container>
          <Grid>
            <div>
              <h2>Design technical assets</h2>
              <p>
              Growing online depends on our capacity to build up our own technological assets.
              Refacturing offers <strong>CTO as a Service</strong> and help you during your business journey to take those technical decisions that impact so much your business.
              </p>
            </div>
            <img src="https://comrefacturingimages.s3-eu-west-1.amazonaws.com/assets.png" style={{"display":"block", "marginLeft": "auto", "marginRight": "auto","width": "100%"}} />
          </Grid>
          <Grid inverse>
          <img src="https://comrefacturingimages.s3-eu-west-1.amazonaws.com/arch.png" style={{"display":"block", "marginLeft": "auto", "marginRight": "auto","width": "100%"}} />
            <div>
              <h2>We develop and manage complex architectures</h2>
              <p>
              When building up web assets it’s necessary to have horizontal skills on multiple stacks, cloud architectures and diverse technologies.
              Our team is available to help you.
              </p>
            </div>
          </Grid>
          <Grid>
            <div>
              <h2>We have a focus on API Economy and StartUp Ecosystem</h2>
              <p>
              Every time we help Startups, Tech companies and Enterpreneurs we specifically focus on <strong>Web API</strong>
              </p>
            </div>
            <img src="https://comrefacturingimages.s3-eu-west-1.amazonaws.com/startu.png" style={{"display":"block", "marginLeft": "auto", "marginRight": "auto","width": "100%"}} />
          </Grid>
        </Container>
      </Section>
    )}
  />
);

const Grid = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr;
  grid-gap: 40px;
  text-align: right;
  align-items: center;
  justify-items: center;
  margin: 24px 0;

  ${props =>
    props.inverse &&
    `
    text-align: left;
    grid-template-columns: 2fr 3fr;
  `}

  h2 {
    margin-bottom: 16px;
  }

  @media (max-width: ${props => props.theme.screen.md}) {
    grid-template-columns: 1fr;
    text-align: left;
    margin-bottom: 96px;

    &:last-child {
      margin-bottom: 24px;
    }

    ${props =>
      props.inverse &&
      `
        ${Art} {
          order: 2;
        }
    `}
  }
`;

const Art = styled.figure`
  margin: 0;
  max-width: 380px;
  width: 100%;
`;

export default About;
